/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const SectionContainer = styled.div`
  .section-podcast-hero--wrapper {
    padding: 0 28px;
    background: ${props => `url(${props.backgroundImg})`};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 100px -130px;
  }

  .section-podcast-hero--container {
    padding: 100px 28px 80px;
    margin: 0 auto;
    text-align: center;
    overflow: visible;

    .section-podcast-hero--main-container {
      max-width: 1010px;
      margin: 0 auto;
      overflow: visible;

      .section-podcast-hero-podcast-container {
        display: flex;
      }

      .section-podcast-hero--image-side {
        position: relative;

        .section-podcast-hero--image-container {
          position: relative;
          margin: 0 auto;

          .section-podcast-hero--image {
            width: 372px;
            box-shadow: 0px 30px 60px rgba(11, 26, 33, 0.15);
          }

          .section-podcast-hero--mark {
            position: absolute;
            width: 40px;
            left: 12px;
            top: 12px;
            background: white;
            border-radius: 50%;
            padding: 7px;
          }

          .section-podcast-hero--detail-button {
            font-family: 'Sofia Pro';
            font-weight: bold;
            font-size: 20px;
            letter-spacing: 0;
            line-height: 32px;
            border: none;
            border-radius: 0 !important;
            cursor: pointer;
            padding: 16px 24px;
            box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
            color: var(--white-color);
            background-color: var(--primary-color);
            transition: background 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            width: 80%;
            position: relative;
            display: block;
            margin: -30px auto 0;
            box-shadow: 0px 30px 60px rgba(11, 26, 33, 0.15);

            &:hover {
              background: var(--primary-hover-color);
            }
          }
        }
      }

      .section-podcast-hero--text-side {
        padding-left: 40px;

        .section-podcast-hero--subtitle {
          font-weight: 500;
          font-size: 13px;
          line-height: 150%;
          color: var(--disabled-text-color);
          text-align: left;
        }

        .section-podcast-hero--title {
          font-weight: 900;
          font-size: 31px;
          line-height: 110%;
          letter-spacing: -0.03em;
          text-align: left;
          margin: 0 auto;
        }

        .section-podcast-hero--description {
          font-weight: 500;
          font-size: 20px;
          line-height: 150%;
          text-align: left;
          margin: 16px 0 10px 0;
        }

        .section-podcast-hero--player {
          background: white;
          margin-top: 25px;
          box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);

          .section-layout--inner-container {
            padding-top: 33px;
            padding-bottom: 33px;
          }
        }
      }
    }
  }

  .section-podcast-hero--favorite-container {
    margin: 90px auto 90px;
    padding: 0;
    margin-bottom: 0;

    .section-podcast-hero--subscribe-container {
      display: flex;
      .section-review-hero--subscribe-form {
        justify-content: left;
      }

      .subscribe-without-padding {
        width: 60%;
        padding-right: 0;
      }
    }
    .section-podcast-hero--favorite-title {
      font-weight: bold;
      font-size: 20px;
      line-height: 120%;
      text-align: left;
      letter-spacing: -0.02em;
      color: var(--black-color);
    }

    .section-podcast-hero--favorite-logo-container {
      max-width: 806px;
      display: flex;
      justify-content: center;
      margin-top: 20px;
      margin-left: 15px;
      max-height: 80px;
      padding-top: 6px;
      padding-left: 13px;
      border-left: var(--disabled-text-color) 1px solid;

      .section-podcast-hero--favorite-logo {
        padding-top: 10px;
        margin: 0 25px;

        .section-podcast-hero--favorite-logo-img {
          width: 54px;
          height: auto;
          max-width: 100%;
        }
      }
    }

    .subscribe-without-padding {
      .section-review-hero--container {
        padding: 0;

        .section-review-hero--description {
          margin-top: 0;
        }

        .section-review-hero--subscribe-content {
          margin-top: 30px;
          padding: 0;

          .section-blog-details-legal-info {
            max-width: 500px;
            margin: 0 auto;
            text-align: center;
            font-family: 'Sofia Pro';
            line-height: 150%;
            text-align: center;
            color: var(--black-color);
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-podcast-hero--wrapper {
      padding: 0 20px;
    }

    .section-podcast-hero--container {
      .section-podcast-hero--main-container {
        .section-podcast-hero-podcast-container {
          flex-direction: column;
        }
        .section-podcast-hero--image-side {
          .section-podcast-hero--image-container {
            max-width: 300px;

            .section-podcast-hero--image {
              width: 272px;
            }

            .section-podcast-hero--mark {
              width: 30px;
              left: 9px;
              top: 9px;
            }

            .section-podcast-hero--detail-button {
              font-size: 16px;
              padding: 8px 24px;
            }
          }
        }

        .section-podcast-hero--text-side {
          padding-left: 30px;

          .section-podcast-hero--title {
            font-size: 23px;
            letter-spacing: -0.02em;
          }

          .section-podcast-hero--description {
            font-size: 17px;
          }
        }
      }
    }

    .section-podcast-hero--favorite-container {
      margin: 60px auto 40px;

      .section-podcast-hero--subscribe-container {
        .subscribe-without-padding {
          width: 100%;
        }
      }

      .section-podcast-hero--subscribe-container {
        flex-direction: column;
      }

      .section-podcast-hero--favorite-title {
        font-size: 20px;
      }

      .section-podcast-hero--favorite-logo-container {
        max-width: 100%;
        margin: 25px auto 0;
        border: 0;

        .section-podcast-hero--favorite-logo {
          margin: 0 20px;

          .section-podcast-hero--favorite-logo-img {
            width: 50px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-podcast-hero--container {
      padding-top: 120px;

      .section-podcast-hero--main-container {
        flex-direction: column;

        .section-podcast-hero--image-side {
          .section-podcast-hero--image-container {
            .section-podcast-hero--image {
              width: 100%;
            }

            .section-podcast-hero--detail-button {
            }
          }
        }

        .section-podcast-hero--text-side {
          padding-left: 0;
          padding-top: 20px;

          .section-podcast-hero--title {
            font-size: 23px;
            letter-spacing: -0.02em;
          }

          .section-podcast-hero--description {
            font-size: 17px;
          }
        }
      }
    }

    .section-podcast-hero--favorite-container {
      margin: 30px auto;

      .section-podcast-hero--favorite-title {
      }

      .section-podcast-hero--favorite-logo-container {
        justify-content: center;
        max-width: 400px;
      }
    }
  }

  @media (max-width: 383px) {
    .section-podcast-hero--favorite-container {
      .section-podcast-hero--favorite-logo-container {
        .section-podcast-hero--favorite-logo {
          padding: 10px 5px;
        }
      }
    }
  }
`;
